import { useCommonReducer } from '@components/Shared/State/hooks';
const useCustomerOrder = (id) => useCommonReducer(`ORDER_${id}`, null);
export default useCustomerOrder;
